/**
 * @generated SignedSource<<d78588cb2bfeadb499c96e74201c735b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CalendarStartDay = "MONDAY" | "SUNDAY";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type RequestBookingDetailsStepNode$data = {
  readonly agenda?: {
    readonly date: string;
    readonly facility: {
      readonly club: {
        readonly calendarStartDay: CalendarStartDay;
        readonly supportsPrivate: boolean;
        readonly supportsPublic: boolean;
      } | null | undefined;
      readonly copyOverrides: {
        readonly course: {
          readonly plural: string;
          readonly singular: string;
        } | null | undefined;
      };
      readonly courseBuckets: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly courses: ReadonlyArray<{
              readonly id: string;
              readonly name: string;
            } | null | undefined>;
            readonly id: string;
            readonly name: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly courseLayouts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly code: string;
            readonly enabled: boolean;
            readonly holeCount: HoleCount;
            readonly id: string;
            readonly memberVisible: boolean;
            readonly name: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly courses: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly lessonDurationMins: ReadonlyArray<number | null | undefined> | null | undefined;
      readonly maxMultipleBookings: number | null | undefined;
      readonly multipleBookingsEnabled: boolean;
      readonly patronRecurringRequestMaximumEndDate: string | null | undefined;
      readonly privateBookingPermissionSet: {
        readonly membersCanMakeRecurringRequests: boolean | null | undefined;
      } | null | undefined;
      readonly type: FacilityType;
    };
    readonly id: string;
    readonly timeSlots: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly availability: SlotAvailability;
          readonly id: string;
          readonly time: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly capacity?: number;
  readonly id?: string;
  readonly " $fragmentSpreads": FragmentRefs<"RequestGroupSizeControlNode">;
  readonly " $fragmentType": "RequestBookingDetailsStepNode";
};
export type RequestBookingDetailsStepNode$key = {
  readonly " $data"?: RequestBookingDetailsStepNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestBookingDetailsStepNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestBookingDetailsStepNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestGroupSizeControlNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 1000
                }
              ],
              "concreteType": "TimeSlotConnection",
              "kind": "LinkedField",
              "name": "timeSlots",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlotEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TimeSlot",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "time",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availability",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "timeSlots(first:1000)"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "calendarStartDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPublic",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonDurationMins",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "patronRecurringRequestMaximumEndDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrivateBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "privateBookingPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "membersCanMakeRecurringRequests",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "maxMultipleBookings",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "multipleBookingsEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "singular",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plural",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Course",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 100
                    }
                  ],
                  "concreteType": "CourseBucketConnection",
                  "kind": "LinkedField",
                  "name": "courseBuckets",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseBucketEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseBucket",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Course",
                              "kind": "LinkedField",
                              "name": "courses",
                              "plural": true,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "courseBuckets(first:100)"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayoutConnection",
                  "kind": "LinkedField",
                  "name": "courseLayouts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayoutEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseLayout",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "code",
                              "storageKey": null
                            },
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "enabled",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "holeCount",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "memberVisible",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "QueueSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "08961236f7be1bf756e3ca8c9d92b6a0";

export default node;
